export default __webpack_public_path__ + "static/media/pilotage.51ecee94.jpeg";